/**
 * This are general methods which can be reused with modal
 */
export function onHide() {
  this.showWindow = false;
  this.$emit('onHide');
}
